import { defineComponent as _defineComponent } from 'vue'
import { NavigationLink } from '~/data/navigation_links_hub_left';

interface Props {
  item: NavigationLink;
  sideNavClosed?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IconLinkContent',
  props: {
    item: null,
    sideNavClosed: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})